import wandu from '../service/wandu';

export default {
    namespace: 'ad',
    state: {
        data: {},
    },
    reducers: {
        update(state, action) {
            return Object.assign({}, { data: action.payload }); 
        }
    },
    effects: {
        *load(action, {put}) {
            const res = yield wandu.site_ad().catch(e => {
                console.log(e);
                return null;
            });
            if (res) {
                yield put({
                    type: 'update',
                    payload: res,
                });
            }
        }
    },
}



// WEBPACK FOOTER //
// ./src/model/ad.js